import { Tooltip } from '@cko/primitives';
import React from 'react';

type AccountSelectorFullTextTooltipProp = {
  className?: string;
  children: React.ReactNode;
  text: string;
};

export const AccountSelectorFullTextTooltip = ({
  className,
  children,
  text,
}: AccountSelectorFullTextTooltipProp) => {
  return (
    <Tooltip text={text} defaultDirection="bottom-start">
      <div className={className}>{children}</div>
    </Tooltip>
  );
};
